import React from "react"

import {
  END_REASON_LABELS,
  END_REASON_VALUES,
} from "@/constants/categorical-metric-values"
import { Checkbox } from "@coval/ui"

import type { MetricRecordData } from "@/types/metrics/contracts"

import {
  FIELD_CONTAINER_STYLES,
  LABEL_ROW_STYLES,
  LABEL_STYLES,
} from "../styles"

const END_REASON_OPTIONS = END_REASON_VALUES.map((value) => ({
  value,
  label: END_REASON_LABELS[value],
}))

interface CustomEndReasonConfigProps {
  metricRecordData: MetricRecordData
  onChange: (metric: MetricRecordData) => void
}

const EMPTY_ARRAY: string[] = []

export const CustomEndReasonConfig: React.FC<CustomEndReasonConfigProps> = ({
  metricRecordData,
  onChange,
}) => {
  const selected =
    metricRecordData.metric_metadata?.success_end_reasons ?? EMPTY_ARRAY

  const handleChange = (values: string[]) => {
    onChange({
      ...metricRecordData,
      metric_metadata: {
        ...metricRecordData.metric_metadata,
        success_end_reasons:
          values as MetricRecordData["metric_metadata"]["success_end_reasons"],
      },
    })
  }

  return (
    <div className="space-y-4">
      <div className={FIELD_CONTAINER_STYLES}>
        <div className={LABEL_ROW_STYLES}>
          <label className={LABEL_STYLES}>
            Success End Reasons{" "}
            <span className="text-coval-danger-text">*</span>
          </label>
        </div>
        <div className="flex flex-col gap-2">
          {END_REASON_OPTIONS.map((option) => (
            <label
              key={option.value}
              className="flex items-center gap-2 text-sm"
            >
              <Checkbox
                checked={selected.includes(option.value)}
                onCheckedChange={(checked) => {
                  const next = checked
                    ? [...selected, option.value]
                    : selected.filter((s) => s !== option.value)
                  handleChange(next)
                }}
              />
              {option.label}
            </label>
          ))}
        </div>
        <p className="text-xs text-coval-text-muted">
          Select which end reasons count as a successful outcome.
        </p>
      </div>
    </div>
  )
}
